"use strict";export function defineElement(e,n){window.__swc,customElements.define(e,n)}
//# sourceMappingURL=define-element.js.map
